(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[584],{

/***/ "vhuI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Information", function() { return Information; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Information = function Information(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 25.016C20.521 25.016 25.013 20.523 25.013 15C25.013 9.478 20.521 4.986 15 4.986C9.477 4.986 4.984 9.478 4.984 15C4.984 20.523 9.477 25.016 15 25.016ZM3 15C3 8.383 8.383 3 15 3C21.617 3 27 8.383 27 15C27 21.617 21.617 27 15 27C8.383 27 3 21.617 3 15ZM15.2925 17.5079H13.6964C13.6852 17.4678 13.6337 17.3215 13.5418 17.0692C13.4499 16.8168 13.4039 16.596 13.4039 16.4067C13.4039 16.0453 13.4526 15.6983 13.5501 15.3657C13.6476 15.033 13.7911 14.7218 13.9805 14.4322C14.1699 14.1425 14.5446 13.6794 15.1045 13.0427C15.6643 12.406 15.9443 11.8812 15.9443 11.4682C15.9443 10.6652 15.4345 10.2637 14.415 10.2637C13.9192 10.2637 13.4011 10.519 12.8607 11.0295L12 9.36896C12.7187 8.78965 13.6629 8.5 14.8329 8.5C15.7354 8.5 16.4889 8.7581 17.0933 9.27432C17.6978 9.79054 18 10.4759 18 11.3306C18 11.9156 17.89 12.4103 17.6699 12.8147C17.4499 13.2191 17.0627 13.6937 16.5084 14.2386C15.954 14.7835 15.5933 15.2366 15.4262 15.5979C15.2591 15.9593 15.1755 16.3551 15.1755 16.7852C15.1755 16.877 15.2145 17.1179 15.2925 17.5079ZM14.5822 18.678C14.961 18.678 15.2827 18.8157 15.5474 19.091C15.812 19.3663 15.9443 19.699 15.9443 20.089C15.9443 20.479 15.812 20.8117 15.5474 21.087C15.2827 21.3623 14.961 21.5 14.5822 21.5C14.2033 21.5 13.8802 21.3623 13.6128 21.087C13.3454 20.8117 13.2117 20.479 13.2117 20.089C13.2117 19.699 13.3454 19.3663 13.6128 19.091C13.8802 18.8157 14.2033 18.678 14.5822 18.678Z"
  }));
};

/***/ })

}]);